<template>
	<div class="sf-input-group-wrapper">
		<!--Ctype-->
		<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001056') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<!--전체-->
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option :key="index" v-for="(item, index) in sCtypeList" :label="item.commCdName" :value="item.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'ctype', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.data = this.searchParams.ctype;
		}
	},
	created() {
		//console.log('조회 값은>>>>>>>>>>>>>>>>>>>>', this.roDdList);

		if (this.searchParams.ctype == null || this.searchParams.ctype == '') this.searchParams.ctype = '';
		this.data = this.searchParams.ctype;
	}
};
</script>

<style></style>
